<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <bootstrap-accordion
            :items="faqsGetter"
            item_id="faq_id"
            item-title="faq_question"
            item-content="faq_answer"
          />
        </div>
      </div>
      <div class="row justify-content-center pt-4 pb-4">
        <bootstrap-pagination
          v-if="pageGetter.page_total > 1"
          :total-page-number="pageGetter.page_total"
          @number:updated="updateFaqPage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BootstrapPagination from '~bootstrap/Pagination'
import { mapActions, mapGetters } from 'vuex'
import BootstrapAccordion from '~bootstrap/Accordion'
export default {
  name: 'FaqContent',
  components: {
    BootstrapAccordion,
    BootstrapPagination
  },
  computed: {
    ...mapGetters('pages/faqs', [
      'faqsGetter',
      'pageGetter'
    ])
  },
  async created () {
    await this.getFaqs()
  },
  methods: {
    ...mapActions('pages/faqs', [
      'getFaqs'
    ]),
    updateFaqPage (page) {
      this.getFaqs(page)
    }
  }
}
</script>
